import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../services/global-environment';
import {
  ApprovalWorkflowConfig,
  DEFAULT_APPROVAL_WORKFLOW_CONFIG
} from '../models/approval-workflow-config.model';

/**
 * 簽核流程配置服務
 *
 * 負責載入和管理簽核流程的客製化配置
 * 如果 API 失敗或配置不存在，會自動使用預設值
 */
@Injectable({
  providedIn: 'root'
})
export class ApprovalWorkflowConfigService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * 取得簽核流程配置
   * @param companyid 公司 ID
   * @returns 配置物件，如果 API 失敗則返回預設值
   */
  async getConfig(companyid: string): Promise<ApprovalWorkflowConfig> {
    try {
      const response = await this.http.get<any>(
        `${this.apiUrl}/api/approval-workflow-config`,
        {
          params: { companyid },
          headers: { 'Content-Type': 'application/json' }
        }
      ).toPromise();

      if (response?.success && response?.data) {
        // 檢查是否為預設配置
        if (response.isDefault) {
          console.log('📋 使用預設簽核流程配置');
        } else {
          console.log('✅ 已載入客製化簽核流程配置');
        }
        return response.data;
      } else {
        console.log('📋 使用預設簽核流程配置');
        return this.getDefaultConfig(companyid);
      }

    } catch (error: any) {
      // API 完全失敗時，使用前端預設值
      console.log('📋 API 暫時無法連線，使用預設簽核流程配置');
      return this.getDefaultConfig(companyid);
    }
  }

  /**
   * 取得預設配置
   * @param companyid 公司 ID
   * @returns 預設配置物件
   */
  private getDefaultConfig(companyid: string): ApprovalWorkflowConfig {
    return {
      ...DEFAULT_APPROVAL_WORKFLOW_CONFIG,
      companyid: companyid
    };
  }
}
